var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"child-course-block",style:(_vm.blockStyle)},_vm._l((_vm.courseStartEndTimes),function(courseStartEndTime,index){return _c('TimelineItem',{key:index,attrs:{"course-start-end-time":courseStartEndTime,"block-start":_vm.blockStart,"block-end":_vm.blockEnd,"block-height":_vm.blockHeight}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }